const Treatments = [
  {
    type: 'Injectable medications',
    labels: [
      'Avonex - Interferon beta-1a',
      'Betaferon - Interferon beta-1b',
      'Betaseron - Interferon beta-1b',
      'Brabio - Glatiramer acetate',
      'Copaxone - Glatiramer acetate',
      'Extavia - Interferon beta-1b',
      'Glatopa - Glatiramer Acetate Injection',
      'Glatiramer Acetate Injection',
      'Kesimpta - Ofatumumab',
      'Plegridy - Peginterferon beta-1a',
      'Rebif - Interferon beta-1a',
      'Other - Please specify | Injectable medications',
    ],
  },
  {
    type: 'Oral medications',
    labels: [
      'Aubagio - Teriflunomide',
      'Bafiertam - Monomethyl Fumarate',
      'Dimethyl Fumarate',
      'Gilenya - Fingolimod',
      'Mavenclad - Cladribine',
      'Mayzent - Siponimod',
      'Ponvery - Ponesimod',
      'Tecfidera - Dimethyl Fumarate',
      'Tascenso ODT - Fingolimod',
      'Vumerity - Diroximel Fumarate',
      'Zeposia - Ozanimod',
      'Other - Please specify | Oral medications',
    ],
  },
  {
    type: 'Infused medications',
    labels: [
      'Briumvi - Ublituximab-xiiy',
      'Lemtrada - Alemtuzumab',
      'Novantrone - Mitoxantrone',
      'Ocrevus - Ocrelizumab',
      'Tysabri - Natalizumab',
      'Other - Please specify | Infused medications',
    ],
  },
  {
    type: 'HSCT',
    labels: ['HSCT - haematopoietic stem cell transplantation'],
  },
  {
    type: 'Other',
    labels: ['Other - Please specify'],
  },
];

export const getTreatmentType = (treatment: string): string => {
  const foundTreatment = Treatments.find(t => t.labels.includes(treatment));
  return foundTreatment ? foundTreatment.type : '';
};

export const getTreatmentOptions = (): JSX.Element[] => {
  const choices = Treatments;
  const options = [];
  let i = 0;
  for (i; i < choices.length; i += 1) {
    options.push(
      <optgroup key={i} label={choices[i].type}>
        {choices[i].labels.map((label, k) => (
          <option key={k} value={label}>
            {label}
          </option>
        ))}
      </optgroup>,
    );
  }
  return options;
};

export const isaTreatment = (treatment: string | undefined): boolean => {
  let isFound = false;
  const choices = Treatments;
  if (treatment !== undefined && treatment !== '') {
    for (let i = 0; i < choices.length; i += 1) {
      // eslint-disable-next-line no-loop-func
      choices[i].labels.forEach(label => {
        if (isFound === false) isFound = label === treatment;
      });
    }
  }
  return isFound;
};

export default Treatments;
